import { render } from "./practice-trust-compliance.html?vue&type=template&id=13904a28&scoped=true&ts=true&external"
import script from "./practice-trust-compliance.ts?vue&type=script&lang=ts&external"
export * from "./practice-trust-compliance.ts?vue&type=script&lang=ts&external"

import "./practice-trust-compliance.scss?vue&type=style&index=0&id=13904a28&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13904a28"]])

export default __exports__